export default __webpack_public_path__ + "static/media/prev.91e683f0.png";